import type { ReactElement } from "react";
import { Fragment } from "react";

import styled from "styled-components";

import { Box } from "@vinomofo/components";

const PlaceholderItem = styled(Box)`
  position: relative;
  height: 17px;
  margin: 0 auto 10px;
  animation-name: placeHolderShimmer;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  border: 1px solid #f5f5f5;
  background: linear-gradient(to right, #f5f5f5 8%, #efefef 18%, #f5f5f5 33%);
  background-size: 800px 104px;
  animation-fill-mode: forwards;
  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }

    100% {
      background-position: 468px 0;
    }
  }
`;

const Title = styled(PlaceholderItem)`
  width: 90%;
  height: 14px;
  margin-bottom: 14px;
`;

const Attributes = styled(PlaceholderItem)`
  width: 50%;
  height: 12px;
  margin-bottom: 14px;
`;

const Price = styled(PlaceholderItem)`
  width: 40%;
  height: 18px;
  margin-bottom: 14px;
`;

const Button = styled(PlaceholderItem)`
  height: 51px;
  margin-bottom: 14px;
  background: #f5f5f5;
  width: 100%;
`;

const PlaceholderDetail = (): ReactElement => {
  return (
    <Fragment>
      <Title />
      <Price />
      <Button />
      <Attributes />
    </Fragment>
  );
};

export default PlaceholderDetail;
